import Pqp from "./Pqp.js";

export default class Lng {
	static l(id, ...rest) {
		if (Pqp.isNullOrEmpty(Lng.data)) {
			Lng.data = TheApp.Res[TheApp.Env.Locale];
		}
		let a = Lng.data;
		let ret = ""
		let value = a[id];
		if (!Pqp.isNullOrEmpty(value)) {
			return Lng.applyValues(value, rest);
		}
		
		console.log("Warning, non trovato idtesto " + id);
		return ret;
	}

	static applyValues(s, parms) {
		let ret = s;
		for (let x = 0; x < parms.length; x++) {
			ret = Pqp.safeReplace(ret, "{{" + x + "}}", "" + parms[x]);
		}
		return ret;
	}

}
Lng.data = null;